import { CookiesProvider } from "react-cookie";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import "./App.css";
import AppProvider from "./context";
import Routes from "./routes/Routes";
// import ThemeComponent from "./components/ThemeComponent/ThemeComponent";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 3,
        },
    },
});

function App() {
    // replace console.* for disable log on production
    if (process.env.NODE_ENV === "production") {
        console.log = () => {};
        console.error = () => {};
        console.debug = () => {};
    }

    return (
        <QueryClientProvider client={queryClient}>
            <CookiesProvider>
                <AppProvider>
                    {/* <ThemeComponent> */}
                    <Routes />
                    {/* </ThemeComponent> */}
                </AppProvider>
            </CookiesProvider>
            <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
        </QueryClientProvider>
    );
}

export default App;
